export default {
  name: 'az',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'Təsdiqlə',
      clear: 'Təmizlə',
      defaultLabel: 'color picker', // to be translated
      description:
        'current color is {color}. press enter to select a new color.', // to be translated
      alphaLabel: 'pick alpha value', // to be translated
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'İndi',
      today: 'Bugün',
      cancel: 'İmtina',
      clear: 'Təmizlə',
      confirm: 'Təsdiqlə',
      dateTablePrompt:
        'Use the arrow keys and enter to select the day of the month', // to be translated
      monthTablePrompt: 'Use the arrow keys and enter to select the month', // to be translated
      yearTablePrompt: 'Use the arrow keys and enter to select the year', // to be translated
      selectedDate: 'Selected date', // to be translated
      selectDate: 'Tarix seç',
      selectTime: 'Saat seç',
      startDate: 'Başlanğıc Tarixi',
      startTime: 'Başlanğıc Saatı',
      endDate: 'Bitmə Tarixi',
      endTime: 'Bitmə Saatı',
      prevYear: 'Öncəki il',
      nextYear: 'Sonrakı il',
      prevMonth: 'Öncəki ay',
      nextMonth: 'Sonrakı ay',
      year: '',
      month1: 'Yanvar',
      month2: 'Fevral',
      month3: 'Mart',
      month4: 'Aprel',
      month5: 'May',
      month6: 'İyun',
      month7: 'İyul',
      month8: 'Avqust',
      month9: 'Sentyabr',
      month10: 'Oktyabr',
      month11: 'Noyabr',
      month12: 'Dekabr',
      weeks: {
        sun: 'Baz',
        mon: 'B.e',
        tue: 'Ç.a',
        wed: 'Çər',
        thu: 'C.a',
        fri: 'Cüm',
        sat: 'Şən',
      },
      weeksFull: {
        sun: 'Sunday', // to be translated
        mon: 'Monday', // to be translated
        tue: 'Tuesday', // to be translated
        wed: 'Wednesday', // to be translated
        thu: 'Thursday', // to be translated
        fri: 'Friday', // to be translated
        sat: 'Saturday', // to be translated
      },
      months: {
        jan: 'Yan',
        feb: 'Fev',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'İyn',
        jul: 'İyl',
        aug: 'Avq',
        sep: 'Sen',
        oct: 'Okt',
        nov: 'Noy',
        dec: 'Dek',
      },
    },
    inputNumber: {
      decrease: 'decrease number', // to be translated
      increase: 'increase number', // to be translated
    },
    select: {
      loading: 'Yüklənir',
      noMatch: 'Nəticə tapılmadı',
      noData: 'Məlumat yoxdur',
      placeholder: 'Seç',
    },
    mention: {
      loading: 'Yüklənir',
    },
    dropdown: {
      toggleDropdown: 'Toggle Dropdown', // to be translated
    },
    cascader: {
      noMatch: 'Nəticə tapılmadı',
      loading: 'Yüklənir',
      placeholder: 'Seç',
      noData: 'Məlumat yoxdur',
    },
    pagination: {
      goto: 'Get',
      pagesize: '/səhifə',
      total: 'Toplam {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
      deprecationWarning:
        'Deprecated usages detected, please refer to the el-pagination documentation for more details', // to be translated
    },
    dialog: {
      close: 'Close this dialog', // to be translated
    },
    drawer: {
      close: 'Close this dialog', // to be translated
    },
    messagebox: {
      title: 'Mesaj',
      confirm: 'Təsdiqlə',
      cancel: 'İmtina',
      error: 'Səhv',
      close: 'Close this dialog', // to be translated
    },
    upload: {
      deleteTip: 'Sürüşdürmədən sonra sil',
      delete: 'Sil',
      preview: 'Ön izlə',
      continue: 'Davam et',
    },
    slider: {
      defaultLabel: 'slider between {min} and {max}', // to be translated
      defaultRangeStartLabel: 'pick start value', // to be translated
      defaultRangeEndLabel: 'pick end value', // to be translated
    },
    table: {
      emptyText: 'Məlumat yoxdur',
      confirmFilter: 'Təsdiqlə',
      resetFilter: 'Sıfırla',
      clearFilter: 'Bütün',
      sumText: 'Cəmi',
    },
    tour: {
      next: 'Next', // to be translated
      previous: 'Previous', // to be translated
      finish: 'Finish', // to be translated
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'Məlumat yoxdur',
    },
    transfer: {
      noMatch: 'Nəticə tapılmadı',
      noData: 'Məlumat yoxdur',
      titles: ['Siyahı 1', 'Siyahı 2'],
      filterPlaceholder: 'Kəlimələri daxil et',
      noCheckedFormat: '{total} ədəd',
      hasCheckedFormat: '{checked}/{total} seçildi',
    },
    image: {
      error: 'SƏHV',
    },
    pageHeader: {
      title: 'Geri',
    },
    popconfirm: {
      confirmButtonText: 'Bəli',
      cancelButtonText: 'Xeyr',
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
    empty: {
      description: 'Məlumat yoxdur',
    },
  },
}
